export const labTest= [
    {
        
        "id":1 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/6b3d644c.svg",
        "head": "Post Prandial Blood Sugar (PPBS)",
        "desc": "Available at 1 certified lab",
        "tests": "",
        "price": 199
    },
    {
        "id":2 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/51ffd21a.svg",
        "head": "Diabetes Care",
        "desc": "Available at 1 certified lab",
        "tests": "Includes 38 tests",
        "price": 499
    },
    {
        "id":3 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/6b3d644c.svg",
        "head": "Covid-19 RTPCR (Coronavirus SARS - CoV2)",
        "desc": "Available at 1 certified lab",
        "tests": "",
        "price": 700
    },
    {
        "id":4 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/51ffd21a.svg",
        "head": "Comprehensive Full Body Checkup with Vitamin D & B12",
        "desc": "Available at 1 certified lab",
        "tests": "Includes 87 tests",
        "price": 1499
    },
    {
        "id":5 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/6b3d644c.svg",
        "head": "Fasting Blood Sugar",
        "desc": "Available at 1 certified lab",
        "tests": "",
        "price": 199
    },
    {
        "id":6 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/51ffd21a.svg",
        "head": "Advanced Full Body Checkup",
        "desc": "Available at 1 certified lab",
        "tests": "Includes 70 tests",
        "price": 999
    },
    {
        "id":7 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/6b3d644c.svg",
        "head": "Creatinine",
        "desc": "Available at 1 certified lab",
        "tests": "",
        "price": 199
    },
    {
        "id":8 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/6b3d644c.svg",
        "head": "Vitamine D Total",
        "desc": "Available at 1 certified lab",
        "tests": "",
        "price": 549
    },
    {
        "id":9 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/51ffd21a.svg",
        "head": "Healthy 2022 Full Body Checkup",
        "desc": "Available at 1 certified lab",
        "tests": "Includes 89 Tests",
        "price": 999
    },
    {
        "id":10 ,
        "img":"https://assets.pharmeasy.in/web-assets/dist/6b3d644c.svg",
        "head": "Thyroide Stimulating Hermone",
        "desc": "Available at 1 certified lab",
        "tests": "",
        "price": 249
    },
    
]
